import React, { useMemo } from 'react';
import { Area, AreaChart, CartesianGrid, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { Advice } from '../../utils/energy';
import { paybackSeries } from '../../utils/energy';
import { euro } from '../../utils/format';
interface PaybackChartProps {
  advice: Advice;
}
export function PaybackChart({
  advice
}: PaybackChartProps) {
  const data = useMemo(() => paybackSeries(advice), [advice]);
  const total = data[data.length - 1].besparing;
  return <section aria-labelledby="payback-title" className="rounded-3xl border border-line bg-white p-5 sm:p-6" data-id="element-448" data-mp="15jmaulyorzcp">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-449" data-mp="1ac5rjrso7alq">
        <div data-id="element-450" data-mp="1faqpfkkg9i70">
          <h2 id="payback-title" className="text-lg font-semibold text-ink" data-id="element-451" data-mp="1fagzfwzenb1b">Terugverdienen over 15 jaar</h2>
          <p className="text-[14px] text-ink-muted" data-id="element-452" data-mp="1kaboduzmdqjq">Uitgaande van 3% stijging van de stroomprijs per jaar</p>
        </div>
        <div className="text-right" data-id="element-453" data-mp="1obf7cqcys2p6">
          <div className="text-[13px] text-ink-muted" data-id="element-454" data-mp="1eavxwx826dbt">Totaal bespaard</div>
          <div className="text-xl font-semibold tabular-nums text-ink" data-id="element-455" data-mp="1e8t2fxo4zrzp">{euro(total)}</div>
        </div>
      </div>
      <div className="mt-5 h-56" data-id="element-456" data-mp="19e5imc42vlrg">
        <ResponsiveContainer width="100%" height="100%" data-id="element-457" data-mp="14bwrllarmtrz">
          <AreaChart data={data} margin={{
          top: 16,
          right: 8,
          bottom: 0,
          left: 0
        }} data-id="element-458" data-mp="14ej7c87t8fla">
            <CartesianGrid vertical={false} stroke="#ECE9DF" data-id="element-459" data-mp="zfpu8gwfqqln" />
            <XAxis dataKey="year" tick={{
            fontSize: 12,
            fill: '#66736C'
          }} tickLine={false} axisLine={false} tickFormatter={(v: number) => `jr ${v}`} interval={2} data-id="element-460" data-mp="1x0c3w02iixzm" />
            <YAxis tick={{
            fontSize: 12,
            fill: '#66736C'
          }} tickLine={false} axisLine={false} width={64} tickFormatter={(v: number) => `€ ${Math.round(v / 1000)}k`} data-id="element-461" data-mp="1nbaooc3skkmp" />
            <Tooltip contentStyle={{
            borderRadius: 12,
            border: '1px solid #DFDBCD',
            fontSize: 13
          }} labelFormatter={v => `Jaar ${v}`} formatter={value => [euro(Number(value)), 'Opgebouwde besparing']} data-id="element-462" data-mp="1ic7ketvmyifs" />
            <ReferenceLine y={advice.product.price} stroke="#0E1B16" strokeDasharray="4 4" label={{
            value: `Investering ${euro(advice.product.price)}`,
            position: 'insideTopLeft',
            fontSize: 12,
            fill: '#0E1B16'
          }} data-id="element-463" data-mp="94nr2r11d2nt" />
            <Area type="monotone" dataKey="besparing" stroke="#1D4A3E" strokeWidth={2.5} fill="#1D4A3E" fillOpacity={0.12} isAnimationActive={false} data-id="element-464" data-mp="4ccpljqnd8t5" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </section>;
}